import { http } from '@pendo/http';

export function fetchSavedViews (type, version = 'v1') {
    return http
        .get(`/api/s/_SID_/savedview?type=${type}&version=${version}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchSavedView (id, version) {
    return http
        .get(`/api/s/_SID_/savedview/${id}${version ? `/version/${version}` : ''}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchVersions (savedviewId) {
    return http
        .get(`/api/s/_SID_/savedview/${savedviewId}/previousVersions`)
        .then((response) => response.data)
        .catch((err) => {
            throw err;
        });
}

export function createSavedView (savedView) {
    return http
        .post('/api/s/_SID_/savedview', savedView)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateSavedView (savedView) {
    return http
        .patch(`/api/s/_SID_/savedview/${savedView.id}`, savedView)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteSavedView (savedViewId) {
    return http.delete(`/api/s/_SID_/savedview/${savedViewId}`).catch((err) => {
        throw err;
    });
}

export function generateSavedViewSummary (feedbackIds, format) {
    return http
        .post('/api/s/_SID_/vocItem/ai/summarize', { ids: feedbackIds, format })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
